import { JSX } from 'react'

import { IconProps } from '../../icon'

const Audio: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M36.9612 8.67412C36.2983 8.12716 35.4364 7.89512 34.5911 8.04429L19.674 10.7625C18.2983 11.0111 17.2873 12.2211 17.2873 13.6133V30.0884C16.442 29.5415 15.4641 29.2265 14.3867 29.2265C11.4199 29.2265 9 31.6464 9 34.6133C9 37.5801 11.4199 40 14.3867 40C17.3536 40 19.7734 37.5801 19.7734 34.6133V19.9117L35.5193 17.0443V25.9448C34.674 25.3978 33.6961 25.0829 32.6187 25.0829C29.6519 25.0829 27.232 27.5028 27.232 30.4696C27.232 33.4365 29.6519 35.8564 32.6187 35.8564C35.5856 35.8564 38.0054 33.4365 38.0054 30.4696V10.9117C38.0054 10.0498 37.6242 9.23765 36.9612 8.69069V8.67412ZM14.3867 37.5138C12.7956 37.5138 11.4862 36.2044 11.4862 34.6133C11.4862 33.0221 12.7956 31.7127 14.3867 31.7127C15.9779 31.7127 17.2873 33.0221 17.2873 34.6133C17.2873 36.2044 15.9779 37.5138 14.3867 37.5138ZM19.7734 17.3758V13.6133C19.7734 13.4144 19.9226 13.2487 20.1215 13.199L35.0386 10.4807C35.2209 10.4476 35.3204 10.5305 35.3867 10.5636C35.4364 10.6133 35.5358 10.7128 35.5358 10.8785V14.4918L19.79 17.3592L19.7734 17.3758ZM32.6187 33.3702C31.0276 33.3702 29.7182 32.0608 29.7182 30.4696C29.7182 28.8785 31.0276 27.5691 32.6187 27.5691C34.2099 27.5691 35.5193 28.8785 35.5193 30.4696C35.5193 32.0608 34.2099 33.3702 32.6187 33.3702Z'
      fill='black'
    />
  </svg>
)

export default Audio
